import { Tag } from '../../tags/tag';
import { EntityInstance } from '../common/entity-instance';
import { Hub } from '../hub/hub';

export class Group extends EntityInstance {
  public rules: string;
  public specialities: Tag[];
  public hub?: Hub;
}
